import { Outlet } from 'react-router-dom';
import { AppShell } from '@/v2/components/shell';
import { GuidedTour } from '@/v2/components/tour/GuidedTour';
import { RouteLoadBoundary } from '@/v2/components/shell/RouteLoadBoundary';

/** Sober DS (v2) dashboard layout — the Sober shell wrapping the v2 route outlet. */
export function DashboardLayout() {
  return (
    <AppShell>
      <RouteLoadBoundary>
        <Outlet />
      </RouteLoadBoundary>
      <GuidedTour />
    </AppShell>
  );
}

export default DashboardLayout;
